/** @format */

import React from "react";
import { Box } from "../../components/layouts/Box";
import { Container } from "../../components/layouts/Container";
import { TitleElement } from "../../components/ui_elements";
import UseStartElement from "../../components/ui_elements/ocnk/UseStart/UseStartElement";
import UseStartLinkElement from "../../components/ui_elements/ocnk/UseStart/UseStartLinkElement";
import useStartHooks from "../../hooks/useStartHooks";
import { BackButton } from "../../components/ui-parts/ocnk/BackButton";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import PdfExplainBox from "../../components/ui-parts/ocnk/PdfExplainBox";

const UseStart = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const {
    useStartData,
    serviceCodeList,
    serviceStatusData,
    phraseByAgent,
    openExamiantionFlagState,
    examinationOpenHandler,
    ContentStatus,
    economicInfoData,
    creditBrandData,
    serviceStopFlag,
    zMaster,
  } = useStartHooks(navigateByAgent);
  return (
    <Container isLogin={true}>
      <TitleElement />
      <div className="mb12 align_right display-mobile">
        <BackButton onClick={() => navigateByAgent("/dashboard")}>ダッシュボードに戻る</BackButton>
      </div>
      <UseStartElement
        managementData={useStartData.managementData}
        serviceData={useStartData.serviceData}
        serviceCodeList={serviceCodeList}
        serviceStatusData={serviceStatusData}
        service={"other"}
        phraseByAgent={phraseByAgent}
        examinationOpenHandler={examinationOpenHandler}
        openExamiantionFlagState={openExamiantionFlagState}
        ContentStatus={ContentStatus}
        economicInfoData={economicInfoData}
        creditBrandData={creditBrandData}
        serviceStopFlag={serviceStopFlag}
        zMaster={zMaster}
      />
      <Box mt={20} />
      <UseStartElement
        service={"atobarai"}
        serviceCodeList={serviceCodeList}
        atobaraiManagementData={useStartData.atobaraiManagementData}
        serviceData={useStartData.serviceData}
        serviceStatusData={serviceStatusData}
        phraseByAgent={phraseByAgent}
        examinationOpenHandler={examinationOpenHandler}
        openExamiantionFlagState={openExamiantionFlagState}
        ContentStatus={ContentStatus}
        economicInfoData={economicInfoData}
        creditBrandData={creditBrandData}
        serviceStopFlag={serviceStopFlag}
        zMaster={zMaster}
      />
      <Box mt={20} />
      <PdfExplainBox />
      <UseStartLinkElement />
    </Container>
  );
};

export default UseStart;
